export default {
  filters: {
    intToDecimal(val) {
      return (val / 100).toFixed(2).replace(".", ",");
    },

    intToCurrency(val) {
      return val ? "R$ " + (val / 100).toFixed(2).replace(".", ",") : "R$ 0,00";
    },

    withZeros(number, length = 2) {
      var res = number.toString();

      while (res.length < length) {
        res = "0" + res;
      }

      return res;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/numberMixin.js